module.exports = __webpack_public_path__ + "assets/img/code2.b3050e32.png";